module.exports = __webpack_public_path__ + "static/media/Gotham-Light.010e1b34.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Light.woff
 ** module id = 1340
 ** module chunks = 0
 **/